import { useParams } from "react-router-dom";
import { MOLECULE_DETAIL_SMILES_KEY } from "@/api/moleculeDetails";
import { useGetMoleculeDetails } from "./hooks";
import {
  MoleculeHeroCard,
  PropertiesCard,
  ExternalDBsCard,
  MoleculeInformationTable,
  DetailsPageSkeleton,
  DetailsPageError,
} from "./_components";

export function DataDetailsPage() {
  const { bsadbId } = useParams<{ bsadbId: string }>();
  const { data, isPending, isError } = useGetMoleculeDetails(bsadbId);

  if (isPending) return <DetailsPageSkeleton />;
  if (isError || !data) return <DetailsPageError />;

  const smiles =
    data.moleculeDetails.items.find(
      (item) => item.key === MOLECULE_DETAIL_SMILES_KEY,
    )?.value ?? null;

  return (
    <div className="flex min-h-screen flex-col bg-backgroundPrimary p-8 pt-16 md:pt-24">
      <div className="mx-auto w-full max-w-7xl">
        <div className="flex flex-col gap-6">
          {/* Top row: molecule card (left) | properties + external dbs (right) */}
          <div className="grid grid-cols-[2fr_3fr] gap-6">
            <MoleculeHeroCard section={data.moleculeDetails} />

            <div className="flex flex-col gap-4 rounded-2xl border border-borderPrimary bg-backgroundSecondary p-5">
              <div className="grid grid-cols-2 gap-5">
                <PropertiesCard section={data.properties} />
                <ExternalDBsCard section={data.externalDBs} smiles={smiles} />
              </div>
            </div>
          </div>

          {/* Bottom: Molecule Information */}
          <MoleculeInformationTable section={data.moleculeInformation} />
        </div>
      </div>
    </div>
  );
}
